import { createFileRoute } from "@tanstack/react-router";

import { RoutinesPage } from "../components/workflows/RoutinesPage";

export const Route = createFileRoute("/routines")({
  component: RoutinesPage,
});
